import axios from '@/api/axios.config'

/** An MDL product's transparent print background, as the backend stored it. */
export type TransparentPrintBackgroundSetting = {
  id: string
  transparent_print_background: boolean
}

/**
 * Turns an MDL product's transparent print background on or off. Final PDFs
 * of a product with it on paint no page background. Super admins only; an M3
 * product's flag is edited in the M3 admin's product editor.
 */
export const updateTransparentPrintBackground = async (
  productId: string,
  enabled: boolean,
) =>
  await axios.patch<TransparentPrintBackgroundSetting>(
    `admin/products/${productId}/transparent-print-background`,
    { enabled },
  )
